export interface UserTeam {
  id: number;
  name: string;
  materializedPath: string;
}

export interface OpportunityCard {
  id: number;
  title: string;
  opportunityType: 'jdi' | 'rie_kaizen' | 'project';
  score?: number;
  primaryImprovementCategory?: string;
  backlogReason?: string[];
  inReviewReason?: string[];
  assignee?: {
    id: number;
    firstName: string;
    lastName: string;
    profileImageUrl?: string;
  };
  teamMembers: {
    id: number;
    firstName: string;
    lastName: string;
    profileImageUrl?: string;
  }[];
  tasksCount: {
    completed: number;
    total: number;
  };
  attachmentsCount: number;
  agingStatus: {
    days: number;
    type: 'since_created' | 'until_due';
    isOverdue?: boolean;
    isWarning?: boolean;
  };
  teamName: string;
  fullTeamName: string;
  status: 'new' | 'in_review' | 'backlog' | 'active' | 'declined' | 'complete' | 'cancelled';
  createdAt: Date;
  dueDate?: Date;
  gembaWalkId?: number;
}

export interface TaskCard {
  id: number;
  title?: string;
  description: string;
  status: 'incomplete' | 'complete';
  dueDate?: Date;
  assignee?: {
    id: number;
    firstName: string;
    lastName: string;
    profileImageUrl?: string;
  };
  opportunityId?: number;
  opportunityTitle?: string;
}

export interface DashboardColumn {
  title: string;
  opportunities?: OpportunityCard[];
  tasks?: TaskCard[];
  count: number;
}

export interface DashboardFilters {
  teamIds: number[];
  myAssignmentsOnly: boolean;
  searchText: string;
}

export interface InProgressDashboardState {
  userTeams: UserTeam[];
  columns: {
    new: DashboardColumn;
    inReview: DashboardColumn;
    backlog: DashboardColumn;
    activeJdi: DashboardColumn;
    activeRieProject: DashboardColumn;
    activeTasks: DashboardColumn;
  };
  filters: DashboardFilters;
  loading: boolean;
  error: string | null;
  isInitialized: boolean;
}

export const initialInProgressDashboardState: InProgressDashboardState = {
  userTeams: [],
  columns: {
    new: { title: 'New', opportunities: [], count: 0 },
    inReview: { title: 'In Review', opportunities: [], count: 0 },
    backlog: { title: 'Backlog', opportunities: [], count: 0 },
    activeJdi: { title: 'Active JDI', opportunities: [], count: 0 },
    activeRieProject: { title: 'Active RIE/Project', opportunities: [], count: 0 },
    activeTasks: { title: 'Active Tasks', tasks: [], count: 0 },
  },
  filters: {
    teamIds: [],
    myAssignmentsOnly: false,
    searchText: '',
  },
  loading: false,
  error: null,
  isInitialized: false,
};